exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form__29SCr{padding:1em .5em}.label__2S_2P{padding:0 1.25em;font-size:.8em;font-weight:700;letter-spacing:.05em;margin-bottom:-.5em;display:block}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/C:/dev/globalTopBar/src/components/sections/personal-area/sections/chat/create-group-chat/styles.scss"],"names":[],"mappings":"AAAA,aACE,gBAAiB,CAClB,cAGC,iBACA,eACA,gBACA,qBACA,oBACA,aAAc,CACf","file":"styles.scss","sourcesContent":[".form {\n  padding: 1em .5em;\n}\n\n.label {\n  padding: 0 1.25em;\n  font-size: .8em;\n  font-weight: 700;\n  letter-spacing: .05em;\n  margin-bottom: -.5em;\n  display: block;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"form": "form__29SCr",
	"label": "label__2S_2P"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/sections/personal-area/sections/chat/create-group-chat/styles.scss
// module id = P06D
// module chunks = 0